<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>{{item}}</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="handleCloseModal">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-blue-2" style="font-size: 77px"> add_shopping_cart </span>
          <h5 class="modal-title">Articulo agregado al carrito con exito!</h5>
          
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-secondary mr-2" @click="handleCloseModal">Seguir navegando</span>
          <span class="btn btn-treid" @click="handleClickSend">Ver carrito</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalAddItemCart",
  props: {
    item: String,
    visible: Boolean,
  },
  methods: {
    handleCloseModal(){
      this.$emit('close')
    },
    handleClickSend(){
      this.$router.push('/carrito');
    },
  }
};
</script>
<style lang="css" scoped>
</style>